/** The rows in their order, each id once: the first row with an id stands for it. */
export function findFirstOfEachId<T extends { id: string }>(rows: readonly T[]): T[] {
    const seen = new Set<string>();
    return rows.filter((row): boolean => {
        if (seen.has(row.id)) {
            return false;
        }
        seen.add(row.id);
        return true;
    });
}
